import React from 'react';
import { Link } from 'react-router-dom';
import { useRef, useState } from "react";

const FaqsCard = (props) => {
  const answerElRef = useRef();
  const [answerH, setAnswerH] = useState("0px");
  const { faqsList, isOpen, onClick } = props;

  // Calculate height when isOpen changes
  React.useEffect(() => {
    if (isOpen) {
      const answerElH = answerElRef.current.childNodes[0].offsetHeight;
      setAnswerH(`${answerElH + 20}px`);
    } else {
      setAnswerH("0px");
    }
  }, [isOpen]);

  return (
    <div
      className="space-y-3 mt-5 overflow-hidden border-b"
      onClick={onClick}
    >
      <h4 className="cursor-pointer pb-5 flex items-center justify-between text-lg text-gray-700 font-medium">
        {faqsList.q}
        {isOpen ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 text-gray-500 ml-2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M20 12H4"
            />
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 text-gray-500 ml-2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 4v16m8-8H4"
            />
          </svg>
        )}
      </h4>
      <div
        ref={answerElRef}
        className="duration-300"
        style={{ height: answerH }}
      >
        <div>
          {faqsList.a.startsWith('<ul>') ? (
            <p className="text-gray-500" dangerouslySetInnerHTML={{ __html: faqsList.a }} />
          ) : (
            <p className="text-gray-500">{faqsList.a}</p>
          )}
        </div>
      </div>
    </div>
  );
};

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const faqsList = [
    {
      q: "What is Ajo App?",
      a: "Ajo App is a digital platform that modernizes traditional thrift contribution methods. It allows users to save money in groups, automate contributions, and receive lump-sum payouts in a secure and organized manner.",
    },
    {
      q: "Who can use Ajo App?",
      a: "Anyone aged 18 and above with a valid email address and a bank account can use Ajo App. It's ideal for individuals, families, and small businesses looking to save collaboratively.",
    },
    {
      q: "How does Ajo App work?",
      a: "Ajo App facilitates group savings by: Allowing users to create or join thrift groups. Automating contributions on a set schedule (weekly, bi-weekly, or monthly). Distributing lump-sum payouts to each group member in a predefined order.",
    },
    {
      q: "How do I sign up for Ajo App?",
      a: "To sign up: Visit www.ajoapp.ca from your browser. Create an account using your email address or phone number. Verify your account/KYC details.",
    },
    {
      q: "Can I create my own thrift group?",
      a: "Yes, you can create a thrift group by naming it, specifying the number of members, setting contribution amounts, and choosing the payout order.",
    },
  ];

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="leading-relaxed max-w-screen-xl mt-12 mx-auto px-4 md:px-8">
      <div className="space-y-3 text-center">
        <h1 className="text-2xl text-gray-800 font-medium">
          Frequently Asked Questions
        </h1>
        <p className="text-gray-600 max-w-lg mx-auto text-lg">
          Answered all frequently asked questions, Still confused? feel free to
          contact us.
        </p>
      </div>
      <div className="mt-14 max-w-2xl mx-auto">
        {faqsList.map((item, idx) => (
          <FaqsCard 
            key={idx}
            faqsList={item}
            isOpen={openIndex === idx}
            onClick={() => handleToggle(idx)}
          />
        ))}
      </div>
      <div className="my-8 max-w-2xl mx-auto">
        <Link
          to='/faqs'
          className='p-3 px-6 pt-2 text-white bg-gray-600 rounded-full baseline hover:bg-gray-700'
        >
          View All FAQs
        </Link>
      </div>
    </section>
  );
};

export default FAQ;